<template>
  <a class="flex justify-center items-center cursor-pointer hover-item" @click.prevent="audio_play()">
    <img src="@/assets/image/gept/voice_play.png" alt="" class="object-contain">
  </a>
</template>

<script>
export default {
  name: 'UserVoice',
  props: {
    ttsUrl: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      sound_effect: new Audio(this.ttsUrl),

      isPlaying: false
    }
  },
  beforeDestroy () {
    if (this.sound_effect.currentTime > 0) {
      this.audio_stop()
    }
  },
  mounted () {
  },
  methods: {
    audio_play () {
      let self = this
      self.sound_effect.play()
      self.sound_effect.addEventListener('play', () => {
        self.isPlaying = true
      })
      self.sound_effect.addEventListener('ended', () => {
        self.audio_stop()

        self.isPlaying = false
      })
    },
    audio_stop () {
      let self = this
      self.sound_effect.pause()
      self.sound_effect.currentTime = 0

      self.isPlaying = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .loading_circle {
    top: 15%;
    left: 15%;
    transform: translate(-50%, -50%);
    animation: spin 2s infinite linear;
    transform-origin: center;
  }
  @keyframes spin  {
    from {
      transform: rotate(0deg);
      transform-origin: center;
    }
    to {
      transform: rotate(360deg);
      transform-origin: center;
    }
  }
  .opacity-50{
    opacity: 0.5;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
</style>
